import { memo, useEffect, useState } from 'react';
import { Icon as BlueIcon } from '@blueprintjs/core';
import { Text as AppText } from '@components';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import { setAttr } from '@utils/setAttr';
import styled from 'styled-components';
import { Highlight, UnstyledButton } from '@mantine/core';
import { IProductSpec } from '@models/ProductSpec.model';
import { HighlightType } from './HighlightType';

interface IProductSpecProps {
  specName: IProductSpec['specName'];
  specDetail: IProductSpec['specDetail'];
  searchTerm?: string;
  hidden?: boolean;
  // Div props
  className?: string | undefined;
}
type ProductSpecType = React.FC<IProductSpecProps>;
function ProductSpec(props: IProductSpecProps) {
  const { specName, specDetail, hidden, searchTerm = '', ...rest } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (hidden) setOpen(false);
  }, [hidden]);

  return (
    <div {...rest}>
      <UnstyledButton
        className="new-icon SpecHead"
        onClick={() => {
          setOpen(!open);
        }}
      >
        {/* Todo: Extract to own component */}
        <AppText<HighlightType>
          component={Highlight}
          text="h300"
          textColor="n800"
          className="Highlight"
          highlight={searchTerm}
        >
          {specName}
        </AppText>
        <BlueIcon
          icon={open ? 'chevron-down' : 'chevron-right'}
          color={COLORS_FLAT.n600}
        />
      </UnstyledButton>

      <div className="ProductSpecDetail" hidden={setAttr(!open)}>
        <AppText text="pl100" className="DetailText">
          {specDetail}
        </AppText>
      </div>
    </div>
  );
}
const StyledProductSpec = styled(ProductSpec)`
  .ProductSpecDetail {
    padding: 8px;
  }
  .DetailText {
    white-space: pre-wrap;
    padding-left: 6px;
  }
  .Highlight span,
  .Highlight mark {
    font: inherit;
    color: inherit;
    display: inline-block;
    white-space: pre-wrap;
  }
  .Highlight mark {
    background-color: ${COLORS_FLAT.n300};
    border-radius: 4px;
    padding: 0 2px;
  }
  .SpecHead {
    padding: 15px 8px 14px 8px;
    border-bottom: 1px solid ${COLORS_FLAT.n300};
  }
`;

export default memo(StyledProductSpec) as ProductSpecType;
